<template>
    <div class="vx-row">
        <div class="vx-col w-full">
            <vx-card :title="movie.title" :subtitle="movie.tagline" id="dataDiv"  class="vs-con-loading__container">

                <div class="vx-row ">
                    <div class="vx-col xl:w-1/3 w-full">
                        <div v-if="editingDisabled">
                            <table class="simple-table" >
                                <tr>
                                    <td class="font-semibold">Worker:</td>
                                    <td>{{ movie.worker_name }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Movie folder:</td>
                                    <td>{{ movie.movie_folder }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Player file:</td>
                                    <td>{{ movie.player_file }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Type:</td>
                                    <td>{{ movieTypeToString(movie.movie_type) }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">TMDB ID:</td>
                                    <td>{{ movie.tmdb_id }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">IMDB ID:</td>
                                    <td>{{ movie.imdb_id }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Poster path:</td>
                                    <td>{{ movie.poster_path }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Backdrop path:</td>
                                    <td>{{ movie.backdrop_path }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Release date:</td>
                                    <td>{{ moment(movie.release_date).format("YYYY/MM/DD") }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Added time:</td>
                                    <td>{{ moment(movie.added_time).format("YYYY/MM/DD HH:mm") }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Runtime:</td>
                                    <td>{{ movie.runtime }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Ratings:</td>
                                    <td>{{ movie.ratings }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Genres:</td>
                                    <td>{{ movie.genres.join(', ') }}</td>
                                </tr>

                            </table>
                            <h6>Overview:</h6>
                            <p class="mt-3">{{ movie.overview }}</p>
                        </div>
                        <div v-else>
                            <p>Worker</p>
                            <vs-select autocomplete class="w-full" v-model="editObject['worker_id']">
                                <vs-select-item :key="key" :value="key" :text="item" v-for="(item, key) in workers" />
                            </vs-select>
                            <p class="mt-6">Movie folder</p>
                            <vs-input v-model="editObject['movie_folder']" class="w-full"/>
                            <div class="vx-row">
                                <div class="vx-col w-1/2">
                                    <p class="mt-6">Player file</p>
                                    <vs-input v-model="editObject['player_file']" class="w-full"/>
                                </div>
                                <div class="vx-col w-1/2">
                                    <p class="mt-6">Movie type</p>
                                    <vs-select autocomplete class="w-full" v-model="editObject['movie_type']">
                                        <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in ['Progressive', 'HLS', 'DASH', 'Smooth Streaming']" />
                                    </vs-select>
                                </div>
                            </div>
                            <div class="vx-row">
                                <div class="vx-col w-1/2">
                                    <p class="mt-6">TMDB ID</p>
                                    <vx-input-group class="mb-base">
                                        <vs-input v-model="editObject['tmdb_id']" class="w-full"/>

                                        <template slot="append">
                                            <div class="append-text btn-addon">
                                                <vs-button color="primary" icon-pack="feather" icon="icon-search" @click="findMovie"/>
                                            </div>
                                        </template>
                                    </vx-input-group>
                                </div>
                                <div class="vx-col w-1/2">
                                    <p class="mt-6">IMDB ID</p>
                                    <vs-input v-model="editObject['imdb_id']" class="w-full"/>
                                </div>
                            </div>
                            <div class="vx-row">
                                <div class="vx-col w-1/2">
                                    <p>Title</p>
                                    <vs-input v-model="editObject['title']" class="w-full"/>
                                </div>
                                <div class="vx-col w-1/2">
                                    <p>Tagline</p>
                                    <vs-input v-model="editObject['tagline']" class="w-full"/>
                                </div>
                            </div>
                            <div class="vx-row">
                                <div class="vx-col w-1/2">
                                    <p class="mt-6">Poster path</p>
                                    <vs-input v-model="editObject['poster_path']" class="w-full"/>
                                    <img v-if="tmdbConfig && editObject['poster_path'].length > 0" :src="tmdbConfig.secure_base_url + 'w342' + editObject['poster_path']" class="w-full mt-3 rounded-lg"/>
                                </div>
                                <div class="vx-col w-1/2">
                                    <p class="mt-6">Backdrop path</p>
                                    <vs-input v-model="editObject['backdrop_path']" class="w-full"/>
                                    <img v-if="tmdbConfig && editObject['backdrop_path'].length > 0" :src="tmdbConfig.secure_base_url + 'w300' + editObject['backdrop_path']" class="w-full mt-3 rounded-lg"/>
                                </div>
                            </div>
                            <div class="vx-row">
                                <div class="vx-col w-1/3">
                                    <p class="mt-6">Release date</p>
                                    <flat-pickr :config="configDateTimePicker" v-model="editObject['release_date']" class="w-full"></flat-pickr>
                                </div>
                                <div class="vx-col w-1/3">
                                    <p class="mt-6">Runtime</p>
                                    <vs-input v-model="editObject['runtime']" class="w-full"/>
                                </div>
                                <div class="vx-col w-1/3">
                                    <p class="mt-6">Ratings</p>
                                    <vs-input v-model="editObject['ratings']" class="w-full"/>
                                </div>
                            </div>

                            <p class="mt-6">Genres</p>
                            <vs-chips color="rgb(145, 32, 159)" placeholder="Add genre" v-model="editObject['genres']">
                                <vs-chip
                                    :key="genre"
                                    @click="removeGenre(genre)"
                                    v-for="genre in editObject['genres']" closable>
                                    {{ genre }}
                                </vs-chip>
                            </vs-chips>

                            <p class="mt-6">Overview</p>
                            <vs-textarea v-model="editObject['overview']" class="w-full"/>
                        </div>
                    </div>
                    <div class="vx-col xl:w-1/3 w-full xl:mt-0 mt-6" v-if="editingDisabled">
                        <h4>Poster</h4>
                        <img v-if="tmdbConfig && movie['poster_path'].length > 0" :src="tmdbConfig.secure_base_url + 'original' + movie['poster_path']" class="w-full mt-3 rounded-lg"/>
                    </div>
                    <div class="vx-col xl:w-1/3 w-full xl:mt-0 mt-6" v-if="editingDisabled">
                        <h4>Backdrop</h4>
                        <img v-if="tmdbConfig && movie['backdrop_path'].length > 0" :src="tmdbConfig.secure_base_url + 'original' + movie['backdrop_path']" class="w-full mt-3 rounded-lg"/>
                    </div>
                    <vs-divider/>
                    <div class="w-full">
                        <vs-button v-if="editingDisabled" style="float: left" color="warning" icon-pack="feather" icon="icon-edit" class="mr-3" @click="editingDisabled = false">Edit</vs-button>
                        <vs-button v-if="editingDisabled" style="float: left" color="primary" icon-pack="feather" icon="icon-play" class="mr-3" @click="getMovieLink">Get link</vs-button>
                        <vs-button v-if="!editingDisabled" style="float: left" color="warning" icon-pack="feather" icon="icon-x" class="mr-3" @click="cancelEdit">Cancel</vs-button>
                        <vs-button v-if="!editingDisabled" style="float: left" color="success" icon-pack="feather" icon="icon-save" class="mr-3" @click="saveMovie">Save</vs-button>
                        <vs-button v-if="!editingDisabled" style="float: right" color="danger" icon-pack="feather" icon="icon-trash-2" class="mr-3" @click="removeMovie">Remove</vs-button>
                    </div>

                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>

    import flatPickr from 'vue-flatpickr-component'
    import 'flatpickr/dist/flatpickr.css'

    export default {
        components: {
            flatPickr
        },
        data(){
            return {

                movie: {
                    title: "",
                    poster_path: "",
                    backdrop_path: "",
                    genres: [],
                },

                editingDisabled: true,
                editObject: {},

                tmdbConfig: null,

                configDateTimePicker: {
                    enableTime: false,
                    dateFormat: 'Y-m-d',
                    time_24hr: false,
                    locale: {
                        firstDayOfWeek: 1
                    }
                },

                workers: {},

            }
        },
        methods: {
            removeGenre(genre) {
                for( let i = 0; i < this.editObject['genres'].length; i++){ if ( this.editObject['genres'][i] === genre) { this.editObject['genres'].splice(i, 1); }}
            },
            cancelEdit(){
                this.editObject = this.movie;
                this.editingDisabled = true;
            },
            loadData() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/vod/movie/' + this.$route.params.id)
                loadPromise.then(function(response) {
                    thisIns.movie = response.data
                    thisIns.editObject = JSON.parse(JSON.stringify(response.data))
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const tmdbConfigPromise = this.$http.get('/api/management/v1/tmdb/config')
                tmdbConfigPromise.then(function(response) {
                    thisIns.tmdbConfig = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const workersPromise = this.$http.get('/api/management/v1/worker/?type=names')
                workersPromise.then(function(response) {
                    thisIns.workers = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([loadPromise, tmdbConfigPromise, workersPromise]).finally(function (){
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            },
            saveMovie(){
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const savePromise = this.$http.put('/api/management/v1/vod/movie/' + this.$route.params.id, {
                    worker_id: Number(this.editObject.worker_id),
                    movie_folder: this.editObject.movie_folder,
                    player_file: this.editObject.player_file,
                    movie_type: Number(this.editObject.movie_type),
                    tmdb_id: this.editObject.tmdb_id,
                    imdb_id: this.editObject.imdb_id,
                    title: this.editObject.title,
                    tagline: this.editObject.tagline,
                    poster_path: this.editObject.poster_path,
                    backdrop_path: this.editObject.backdrop_path,
                    release_date: this.moment(this.editObject.release_date).format(),
                    runtime: this.editObject.runtime,
                    ratings: this.editObject.ratings,
                    overview: this.editObject.overview,
                    genres: this.editObject.genres
                })

                savePromise.then(function(response) {
                    thisIns.editingDisabled = true
                    thisIns.$printSuccess('Movie saved')
                    thisIns.$nextTick(() => {
                        thisIns.loadData();
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            },
            removeMovie(){
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const removePromise = this.$http.delete('/api/management/v1/vod/movie/' + this.$route.params.id)
                removePromise.then(function() {
                    thisIns.$nextTick(() => {
                        thisIns.$router.go(-1);
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            },
            findMovie(){
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/tmdb/find/' + this.editObject.tmdb_id)
                loadPromise.then(function(response) {
                    let oldObject = thisIns.editObject
                    thisIns.editObject = response.data
                    thisIns.editObject.worker_id = oldObject.worker_id
                    thisIns.editObject.movie_folder = oldObject.movie_folder
                    thisIns.editObject.player_file = oldObject.player_file
                    thisIns.$printSuccess("Movie found!")
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function (){
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            },
            movieTypeToString(type){
                switch (type){
                    case 0: return "Progressive";
                    case 1: return "HLS";
                    case 2: return "DASH";
                    case 3: return "Smooth Streaming";
                    default: return "Unknown";
                }

            },
            getMovieLink() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const reqPromise = this.$http.get('/api/management/v1/vod/movie/' + this.$route.params.id + '/link')
                reqPromise.then(function(response) {
                    const newLink = response.data
                    thisIns.$copyText(response.data).then(function() {
                        thisIns.$printSuccess('Link copied to clipboard')
                    }, function() {
                        alert(newLink)
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            }
        },
        mounted() {
            this.loadData()
        }
    }

</script>
<style lang="scss" scoped>
.simple-table {
    td {
        vertical-align: top;
        min-width: 125px;
        padding-bottom: 0.5rem;
        word-break: break-all;

        @media screen and (max-width:370px) {
            display: block;
        }
    }
}

</style>
